import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import PageStructure from 'flarum/forum/components/PageStructure';
import extractText from 'flarum/common/utils/extractText';
import { canManageConsent, showConsentSettings } from '../consent';
const UPDATED_AT = '2026-09-02';
const PRIVACY_EMAIL = 'privacy@aooci.com';
export default class PrivacyPage extends Page {
  bodyClass = 'App--aoociPrivacy';
  oninit(vnode) {
    super.oninit(vnode);
    app.history.push('aoociPrivacy', extractText(app.translator.trans('aooci-adsense.forum.policy.title')));
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    app.setTitle(extractText(app.translator.trans('aooci-adsense.forum.policy.title')));
    app.setTitleCount(0);
  }
  view() {
    const cookieRows = [['flarum_session', 'aooci', 'session_purpose', 'session_duration', 'necessary'], ['flarum_remember', 'aooci', 'remember_purpose', 'remember_duration', 'necessary'], ['google', 'google_provider', 'google_purpose', 'google_duration', 'optional']];
    const trans = function (key, params) {
      if (params === void 0) {
        params = {};
      }
      return app.translator.trans(`aooci-adsense.forum.policy.${key}`, params);
    };
    return m(PageStructure, {
      className: "AoociPrivacyPage"
    }, m("article", {
      className: "AoociLegalPage-card"
    }, m("h1", null, trans('title')), m("p", {
      className: "AoociLegalPage-updated"
    }, trans('updated', {
      date: UPDATED_AT
    })), m("p", null, trans('summary')), m("h2", null, trans('cookies_heading')), m("div", {
      className: "AoociLegalPage-tableWrap"
    }, m("table", null, m("thead", null, m("tr", null, m("th", null, trans('cookies.name_heading')), m("th", null, trans('cookies.provider_heading')), m("th", null, trans('cookies.purpose_heading')), m("th", null, trans('cookies.duration_heading')), m("th", null, trans('cookies.category_heading')))), m("tbody", null, cookieRows.map(_ref => {
      let [name, provider, purpose, duration, category] = _ref;
      return m("tr", null, m("th", {
        scope: "row"
      }, trans(`cookies.${name}`)), m("td", null, trans(`cookies.${provider}`)), m("td", null, trans(`cookies.${purpose}`)), m("td", null, trans(`cookies.${duration}`)), m("td", null, trans(`cookies.${category}`)));
    })))), m("h2", null, trans('choices_heading')), m("p", null, trans('choices_text')), canManageConsent() ? m("p", null, m("button", {
      className: "Button",
      type: "button",
      onclick: showConsentSettings
    }, app.translator.trans('aooci-adsense.forum.footer.settings_button'))) : null, m("h2", null, trans('data_heading')), m("p", null, trans('data_text')), m("p", null, trans('phone_text')), m("h2", null, trans('rights_heading')), m("p", null, trans('rights_text')), m("h2", null, trans('contact_heading')), m("p", null, trans('contact_text'), " ", m("a", {
      href: `mailto:${PRIVACY_EMAIL}`
    }, PRIVACY_EMAIL)), m("p", null, m("a", {
      href: "https://policies.google.com/privacy",
      target: "_blank",
      rel: "noopener noreferrer"
    }, trans('google_privacy_link')))));
  }
}
flarum.reg.add('aooci-adsense', 'forum/components/PrivacyPage', PrivacyPage);